import { useState } from "react";
import { relics } from "../../game/data";
import type { PlayerState } from "../../game/playerState";

interface Props {
  state: PlayerState;
  update: (mutate: (draft: PlayerState) => void) => void;
}

export function RelicsPanel({ state, update }: Props) {
  const [filter, setFilter] = useState("");
  const q = filter.trim().toLowerCase();
  const visible = q
    ? relics.filter(
        (r) => r.name.toLowerCase().includes(q) || (r.bonusType ?? "").toLowerCase().includes(q),
      )
    : relics;
  const owned = relics.filter((r) => state.relics[r.id]).length;

  return (
    <div className="panel">
      <div className="panel-header">
        <input
          className="search"
          type="search"
          placeholder={`Search ${relics.length} relics…`}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        <span className="counter">
          {owned}/{relics.length}
        </span>
      </div>
      <div className="relic-grid">
        {visible.map((r) => {
          const has = state.relics[r.id] ?? false;
          return (
            <button
              key={r.id}
              className={`relic rarity-${r.rarity}${has ? " owned" : ""}`}
              title={`${r.bonusType ?? "?"} ${typeof r.value === "number" ? `+${r.value * 100}%` : (r.value ?? "")}\n${r.unlockedBy ?? ""}`}
              onClick={() =>
                update((draft) => {
                  draft.relics[r.id] = !has;
                })
              }
            >
              <span className="relic-name">{r.name}</span>
              <span className="relic-bonus">{r.bonusType}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
